import { render, staticRenderFns } from "./page-idea.vue?vue&type=template&id=fe641eea"
import script from "./page-idea.js?vue&type=script&lang=js&external"
export * from "./page-idea.js?vue&type=script&lang=js&external"
import style0 from "./page-idea.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports